<div
  (click)="$event.stopPropagation()"
  class="tw-flex tw-h-full tw-border-t tw-border-t-color-border-subtle tw-border-l-0 tw-border-r-0 tw-border-b-0"
>
  <div class="tw-w-1 tw-bg-accent tw-shrink-0"></div>
  <div class="tw-flex-1 tw-min-w-0 tw-py-3 tw-px-4">
    <div class="tw-flex tw-items-center tw-gap-1 tw-mb-1">
      <span class="tw-text-orange-400">⚡</span>
      <span class="tw-font-semibold tw-text-sm tw-text-color-text-default">{{
        "alternativeWaysToSpend" | i18n
      }}</span>
    </div>
    <div class="tw-text-xs tw-text-color-text-tertiary tw-tracking-wider tw-mb-3">
      {{ "saveWithCoupons" | i18n }}
    </div>
    <div class="tw-relative">
      <div
        appGlossScroll
        #couponsScroll
        class="tw-flex tw-overflow-x-auto tw-overscroll-x-contain tw-scroll-smooth tw-gap-3 tw-px-2 tw--mx-2 sm:tw-pb-3 auto-hide-scrollbar"
        (scroll)="onCouponsScroll()"
      >
        @for (coupon of coupons; track coupon.id) {
          @let meta = displayMeta(coupon.id);
          <div
            class="tw-flex tw-flex-col tw-gap-1.5 tw-w-[180px] tw-shrink-0 tw-bg-color-surface-card tw-rounded-xl tw-p-3 tw-border tw-border-color-border-subtle"
          >
            <div
              [ngClass]="meta.colorClass"
              class="tw-w-9 tw-h-9 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-font-bold tw-text-xs tw-border tw-shrink-0"
            >
              {{ meta.initials }}
            </div>
            <span
              class="tw-block tw-w-full tw-whitespace-normal tw-font-semibold tw-text-sm tw-text-color-text-default tw-break-words tw-line-clamp-2"
              >{{ coupon.attribute }}</span
            >
            <span
              class="tw-block tw-w-full tw-whitespace-normal tw-text-xs tw-text-color-text-secondary tw-leading-snug tw-break-words tw-line-clamp-2"
              >{{ coupon.OfferOnCard }}</span
            >
            <button
              (click)="onViewCoupon(coupon); $event.stopPropagation()"
              class="tw-inline-flex tw-self-start tw-items-center tw-gap-1 tw-text-xs tw-text-color-focus-past hover:tw-text-color-focus-past bg-tint-accent-past-40 tw-border tw-border-color-focus-past tw-rounded-full tw-py-1 tw-px-2 tw-no-underline tw-mt-auto tw-cursor-pointer"
            >
              {{ "viewLink" | i18n }}
              <icon
                [name]="'external-link-01'"
                [size]="3"
                [currentColor]="'color-focus-past'"
              ></icon>
            </button>
          </div>
        }
      </div>

      @if (canScrollCouponsLeft()) {
        <button
          type="button"
          [attr.aria-label]="'scrollLeft' | i18n"
          class="tw-hidden lg:tw-flex tw-absolute tw-left-0 tw-top-1/2 tw--translate-y-1/2 tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-dt-custom-teal-11 tw-bg-dt-custom-teal-3"
          (click)="scrollCoupons(-1)"
        >
          <icon
            name="right-arrow"
            [size]="4"
            [currentColor]="'dt-custom-teal-11'"
            class="tw-rotate-180"
          ></icon>
        </button>
      }
      @if (canScrollCouponsRight()) {
        <button
          type="button"
          [attr.aria-label]="'scrollRight' | i18n"
          class="tw-hidden lg:tw-flex tw-absolute tw-right-0 tw-top-1/2 tw--translate-y-1/2 tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-dt-custom-teal-11 tw-bg-dt-custom-teal-3"
          (click)="scrollCoupons(1)"
        >
          <icon name="right-arrow" [size]="4" [currentColor]="'dt-custom-teal-11'"></icon>
        </button>
      }
    </div>
  </div>
</div>
